<template>
    <div>
        <slot name="Pimage"></slot>
        <slot name="Pname"></slot>
        <slot name="description"></slot>
        <slot name="github"></slot>
        <slot name="live"></slot>
    </div>
</template>
<script> 
export default {
    
}
</script>
<style>
    
</style>